var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Footer',{staticClass:"FooterLanding"},[_c('Wrap',{staticClass:"lg"},[_c('HowToOrder',{attrs:{"classes":"inv single-line"}})],1),_c('Wrap',{staticClass:"md"},[_vm._t("form",[_c('FormSignup',{attrs:{"id":"signup"}})])],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }